import React from 'react';

export class Wrapper extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const p = this.props;
        return (
            <div className   = { `marketkit-checkbox-wrapper` }>
                { p.children }
            </div>
        )
    }
}

export default Wrapper;